export default "__VITE_ASSET__CufgQ6gF__"